(() => {
  if (window.KindraEnquiries) return;
  const config = document.querySelector('[data-kindra-enquiry-config]');
  if (!config) return;
  const preview = config.dataset.preview === 'true' || !!window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main';
  const prefix = `kindra.enquiry.v1.${preview ? 'draft' : 'live'}.`;
  const now = () => Date.now();
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(prefix + key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(prefix + key, JSON.stringify(value)); return true; } catch { return false; } };
  const remove = key => { try { sessionStorage.removeItem(prefix + key); } catch {} };
  const clean = value => String(value || '').replace(/[^a-zA-Z0-9 ._~:/+-]/g, '').slice(0, 100);
  const utmKeys = ['source', 'medium', 'campaign', 'content', 'term'];
  let attribution = null;
  let completed = new Set();
  let googleReady = false;
  const path = location.pathname;
  const contactSuccess = new URL(config.dataset.contactSuccessUrl || '/pages/contact-success', location.origin);
  const uuid = () => crypto.randomUUID();
  function touch() {
    const params = new URLSearchParams(location.search);
    const result = { landing_page: path };
    let tagged = false;
    utmKeys.forEach(key => {
      const value = clean(params.get('utm_' + key));
      if (value) { result['utm_' + key] = value; tagged = true; }
    });
    try {
      const referrer = new URL(document.referrer);
      if (referrer.host !== location.host) result.referrer = referrer.hostname;
    } catch {}
    return { result, external: tagged || !!result.referrer };
  }
  function captureAttribution() {
    if (!allowed()) {
      attribution = null;
      remove('attribution');
      if (googleReady) {
        const tag = function () { window.kindraLeadLayer.push(arguments); };
        tag('consent', 'update', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
      }
      return;
    }
    const previous = read('attribution');
    const current = touch();
    const valid = previous && now() - previous.updated < 30 * 60 * 1000;
    attribution = {
      first: valid ? previous.first : current.result,
      last: valid && !current.external ? previous.last : current.result,
      updated: now()
    };
    write('attribution', attribution);
  }
  function prepare(form, marker) {
    const pendingKey = 'pending.' + form.id;
    const old = read(pendingKey);
    const id = old && now() - old.created < 30 * 60 * 1000 ? old.id : uuid();
    const country = form.elements.namedItem('contact[Country]')?.value || config.dataset.countryName;
    const referral = form.elements.namedItem('contact[How did you first hear about us?]');
    const attr = allowed() ? attribution : null;
    const referralSource = referral?.selectedOptions?.[0]?.dataset?.referralSource || referral?.value;
    const pending = { id, created: now(), form_id: form.id, enquiry_type: marker.dataset.kindraEnquiry, enquiry_country: clean(country), storefront_market: clean(marker.dataset.market), form_location: path, referral_source: clean(referralSource), attribution: attr };
    if (marker.dataset.kindraEnquiry === 'contact') {
      let redirect = form.elements.namedItem('return_to');
      if (!redirect) { redirect = document.createElement('input'); redirect.type = 'hidden'; redirect.name = 'return_to'; form.append(redirect); }
      const url = new URL(contactSuccess);
      const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview && previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
      url.searchParams.set('contact_posted', 'true');
      url.hash = form.id;
      redirect.value = url.pathname + url.search + url.hash;
      pending.return_path = url.pathname;
    }
    write(pendingKey, pending);
  }
  function sendGoogle(data) {
    if (!allowed() || preview || !/^G-[A-Z0-9]+$/.test(config.dataset.ga4 || '')) return;
    window.kindraLeadLayer = window.kindraLeadLayer || [];
    const tag = function () { window.kindraLeadLayer.push(arguments); };
    if (!googleReady) {
      googleReady = true;
      tag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
      tag('js', new Date());
      tag('config', config.dataset.ga4, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${config.dataset.ga4}&l=kindraLeadLayer`;
      document.head.append(script);
    }
    tag('event', 'generate_lead', { ...data, send_to: config.dataset.ga4, page_location: location.origin + path, page_referrer: '', transport_type: 'beacon' });
  }
  function confirm(form, marker) {
    if (marker.dataset.success !== 'true' || marker.dataset.errors === 'true') return;
    const key = 'pending.' + form.id;
    const pending = read(key);
    if (!pending || pending.form_id !== form.id || pending.form_location !== path || now() - pending.created > 30 * 60 * 1000 || location.hash !== '#' + form.id || completed.has(pending.id)) return;
    reportConfirmation(pending, key);
  }
  function confirmContactSuccess() {
    if (path !== contactSuccess.pathname || new URLSearchParams(location.search).get('contact_posted') !== 'true') return;
    const formId = location.hash.slice(1);
    if (!formId) return;
    const key = 'pending.' + formId;
    const pending = read(key);
    if (!pending || pending.enquiry_type !== 'contact' || pending.form_id !== formId || pending.return_path !== path || now() - pending.created > 30 * 60 * 1000) return;
    reportConfirmation(pending, key);
  }
  function reportConfirmation(pending, key) {
    if (!allowed() || completed.has(pending.id)) return;
    completed.add(pending.id);
    remove(key);
    const data = {
      submission_id: pending.id,
      enquiry_type: pending.enquiry_type,
      enquiry_country: pending.enquiry_country,
      storefront_market: pending.storefront_market,
      form_location: pending.form_location,
      referral_source: pending.referral_source,
      enquiry_source: pending.attribution?.last?.utm_source || pending.attribution?.last?.referrer || 'direct_or_unknown',
      enquiry_medium: pending.attribution?.last?.utm_medium || 'unknown',
      enquiry_campaign: pending.attribution?.last?.utm_campaign || 'none',
      first_source: pending.attribution?.first?.utm_source || pending.attribution?.first?.referrer || 'direct_or_unknown',
      first_campaign: pending.attribution?.first?.utm_campaign || 'none'
    };
    window.KindraEnquiries.lastConfirmation = { ...data, environment: preview ? 'draft' : 'live' };
    document.dispatchEvent(new CustomEvent('kindra:enquiry-confirmed', { detail: window.KindraEnquiries.lastConfirmation }));
    if (!preview) {
      window.Shopify?.analytics?.publish?.('kindra_enquiry_submitted', data);
      sendGoogle(data);
    }
  }
  function init() {
    confirmContactSuccess();
    document.querySelectorAll('[data-kindra-enquiry]').forEach(marker => {
      const form = marker.closest('form');
      if (!form) return;
      const country = form.elements.namedItem('contact[Country]');
      if (country?.tagName === 'SELECT' && !country.dataset.prefilled) {
        const previous = read('pending.' + form.id);
        country.value = marker.dataset.errors === 'true' && previous ? previous.enquiry_country : config.dataset.countryName;
        if (!country.value) {
          country.value = 'Other';
          if (!country.value) country.selectedIndex = 0;
        }
        country.dataset.prefilled = 'true';
      }
      if (!form.dataset.enquiryBound) {
        form.dataset.enquiryBound = 'true';
        form.addEventListener('submit', event => {
          if (window.Shopify?.designMode) {
            event.preventDefault();
            const status = form.querySelector('[data-enquiry-status]');
            if (status) status.textContent = config.dataset.editorMessage;
            return;
          }
          if (!form.checkValidity()) return;
          prepare(form, marker);
        }, true);
      }
      const referral = form.elements.namedItem('contact[How did you first hear about us?]');
      const previous = read('pending.' + form.id);
      if (marker.dataset.errors === 'true' && referral && previous && !referral.dataset.restored) {
        const restored = Array.from(referral.options).find(option => (option.dataset.referralSource || option.value) === previous.referral_source);
        referral.value = restored?.value || '';
        referral.dataset.restored = 'true';
      }
      confirm(form, marker);
    });
  }
  window.KindraEnquiries = { lastConfirmation: null };
  function privacyReady() { captureAttribution(); init(); }
  init();
  if (window.Shopify?.customerPrivacy) privacyReady();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) privacyReady(); });
  document.addEventListener('visitorConsentCollected', privacyReady);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();
